import React from 'react'
import {Link} from 'react-router-dom'

import {injectCartContainer} from '../../react/CartContainer'
import {injectShopContainer} from '../../react/ShopDataContainer'

// Ordering-app sticky top bar for Baldwin Park Pizza Co.
// The marketing site is a separate Astro deploy at the apex domain, so the
// home/logo link is an absolute, full-page navigation back to it (NOT a
// react-router <Link>) — this leaves the ordering SPA entirely.
const MARKETING_HOME = 'https://baldwinparkpizzaco.com'

function CartBar ({cart, shop}) {
  if (!shop) { return null }

  const numberOfItems = (cart.state.products || []).length

  return (
    <div role="navigation" aria-label="primary" className="cart-wrapper">
      <div className="cart minimized">
        <div className="home-link-wrapper">
          <a href={MARKETING_HOME} className="home-link" aria-label="Baldwin Park Pizza Co. home">
            <span className="nav__slice" aria-hidden="true"></span>
            <span className="nav-bar-brand">
              Baldwin Park
              <small>PIZZA CO.</small>
            </span>
          </a>
        </div>

        <div className="tool-bar">
          <Link
            aria-label="shopping cart"
            to={{pathname: "/checkout", state: {fromMini: true}}}
            className="checkout-button button">cart ({numberOfItems})</Link>
        </div>
      </div>
    </div>
  )
}

export default injectCartContainer(injectShopContainer(CartBar))
